/**
 * Branded number types for currency / percentage discrimination.
 *
 * `declare global` 让 `Cents` / `MajorUnitAmount` / `Bp` 全局可见,以便从 shared
 * crate rsync 过来的 `generated/ts-rs/*.ts` 无需 import 即可引用 (它们由 ts-rs
 * 在 red_coral 上下文生成,假设这些类型是全局符号)。命名 export 保持向后兼容
 * console 自身代码 (`import { asCents, type Cents } from '@/core/types/money'`).
 */

declare global {
  type Cents = number & { readonly __brand: 'Cents' };
  type MajorUnitAmount = number & { readonly __brand: 'MajorUnitAmount' };
  type Bp = number & { readonly __brand: 'Bp' };
}

export type { Cents, MajorUnitAmount, Bp };

export const asCents = (value: number): Cents => value as Cents;
export const asMajorUnitAmount = (value: number): MajorUnitAmount => value as MajorUnitAmount;
export const asBp = (value: number): Bp => value as Bp;
